<template>
  <div class="ui-wrap app-container">
    <div class="ui-box fill-box">
      <div class="row">
        <div class="lab require">{{ $t('form.Surname') }}:</div>
        <div class="content" :class="{ isError: empty.lastName }">
          <input
            type="text"
            v-model="info.lastName"
            @focus="resetErr('lastName')"
            @blur="isEmpty('lastName')"
            class="fill-input"
          />
          <p class="ui-error">{{ $t('formRule.surname') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.midName') }}:</div>
        <div class="content" :class="{ isError: empty.firstName }">
          <input
            type="text"
            v-model="info.firstName"
            @focus="resetErr('firstName')"
            @blur="isEmpty('firstName')"
            class="fill-input"
          />
          <p class="ui-error">{{ $t('formRule.name') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.birth') }}:</div>
        <div class="content" :class="{ isError: empty.birthday }">
          <!-- <input
            type="text"
            v-model="info.birthday"
            @focus="resetErr('birthday')"
            placeholder="DD/MM/YYYY"
            class="fill-input app-birthday"
          /> -->
          <div class="app-birthday1">
            {{ momentInfo }}
          </div>
          <el-date-picker
            style="width: 100%"
            class="ui-datepicker birthday"
            @click="resetErr('birthday')"
            type="date"
            v-model="info.birthday"
            value-format="yyyy-MM-dd"
          ></el-date-picker>

          <van-date
            @change="changeBirth"
            v-model="info.birthday"
            type="date"
            :title="$t('form.birth')"
            class="app-birthday1"
            :show-toolbar="false"
            :min-date="minDate"
          />
          <p class="ui-error">{{ $t('formRule.birthday') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.gender') }}:</div>
        <div class="content">
          <label
            class="ui-radio"
            :class="{ checked: info.sex === 1 }"
            @click="info.sex = 1"
            >{{ $t('common.man') }}</label
          >
          <label
            class="ui-radio"
            :class="{ checked: info.sex === 2 }"
            @click="info.sex = 2"
            >{{ $t('common.female') }}</label
          >
          <!-- <label class="ui-radio" :class="{checked: info.sex === 0}" @click="info.sex = 0">{{$t("common.other")}}</label> -->
        </div>
      </div>
      <div class="row app-studentId">
        <!-- require -->
        <!-- :class="{ isError: empty.studentIdCard }" -->
        <div class="lab">{{ $t('form.studentId') }}:</div>
        <div class="content">
          <el-upload
            class="uploadStudentId"
            :headers="myHeaders"
            :action="uploadUrl"
            :on-success="uploadSuccess"
            :data="uploadData"
            name="uploadFile"
            :with-credentials="true"
            :multiple="false"
          >
            <span class="fill-input">{{ getStudentId() }}</span>
            <a class="btn-upload">{{ $t('form.upload') }}</a>
          </el-upload>
          <!-- <p class="ui-error">{{ $t('formRule.studentId') }}</p> -->
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.email') }}:</div>
        <div class="content" :class="{ isError: empty.linkEmail }">
          <input
            type="text"
            v-model="info.linkEmail"
            class="fill-input"
            @focus="resetErr('linkEmail')"
            @blur="isEmpty('linkEmail')"
          />
          <!-- 邮件不能为空 -->
          <p class="ui-error">{{ $t('formRule.email') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.telphone') }}:</div>
        <div class="content" :class="{ isError: empty.linkMobileNo }">
          <input
            type="text"
            v-model="info.linkMobileNo"
            class="fill-input"
            @focus="resetErr('linkMobileNo')"
            @blur="isEmpty('linkMobileNo')"
          />
          <!-- 手机号不能为空 -->
          <p class="ui-error">{{ $t('formRule.phone') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab">Skype:</div>
        <div class="content">
          <input
            type="text"
            v-model="info.skype"
            class="fill-input"
            @focus="resetErr('wechat')"
          />
          <!-- @blur="isEmpty('wechat')" -->
        </div>
      </div>
      <div class="row">
        <div class="lab">{{ $t('wechart') }}:</div>
        <!-- :class="{ isError: empty.wechat }" -->
        <div class="content">
          <input
            type="text"
            v-model="info.wechat"
            class="fill-input"
            @focus="resetErr('wechat')"
          />
          <!--   @blur="isEmpty('wechat')" -->
          <!-- Skype 与 Wechat 不能同时为空 -->
          <!-- <p class="ui-error">{{ $t('formRule.skypeWechat') }}</p> -->
        </div>
      </div>
      <div class="row">
        <!-- require  :class="{ isError: empty.school }"-->
        <div class="lab">{{ $t('form.school') }}:</div>
        <div class="content">
          <input type="text" v-model="info.school" class="fill-input" />
          <!--
            @focus="resetErr('school')"
            @blur="isEmpty('school')" -->
          <!-- 当前学校不能为空 -->
          <!-- <p class="ui-error">{{ $t('formRule.school') }}</p> -->
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.grade') }}:</div>
        <!-- currentSchoolYear -->
        <div
          class="content englishLevel"
          :class="{ isError: empty.schoolYear }"
        >
          <!-- <input
            type="text"
            v-model="info.schoolYear"
            class="fill-input"
            @focus="resetErr('schoolYear')"
            @blur="isEmpty('schoolYear')"
          /> -->
          <!--  当前年级不能为空 -->
          <!-- <p class="ui-error">{{ $t('formRule.schoolYear') }}</p> -->
          <el-select v-model="info.schoolYear" class="ui-select">
            <el-option
              v-for="item in currentSchoolYear"
              :key="item.value"
              :value="item.value"
              :label="item.name"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.englishLevel') }}:</div>
        <div class="content englishLevel">
          <el-select v-model="info.englishSpokenLevel" class="ui-select">
            <el-option
              v-for="item in levelArr"
              :key="item.value"
              :value="item.value"
              :label="item.name"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="lab require">A-Level or IB:</div>
        <div class="content">
          <label
            v-for="item in courseList"
            :key="item.courseId"
            class="ui-radio"
            :class="{ checked: info.course == item.courseId }"
            @click="info.course = item.courseId"
            >{{ item.courseName }}</label
          >
        </div>
      </div>
      <div class="row">
        <!-- require -->
        <!-- {{subjectList}} -->
        <div class="lab">{{ $t('form.subject') }}：</div>
        <div class="content" :class="{ isError: empty.studiedSubjects }">
          <table
            v-for="item in subjectList"
            :key="item.courseId"
            v-show="info.course == item.courseId"
          >
            <tr v-for="cell in item.arr" :key="cell.subjectId">
              <td @click="empty.studiedSubjects = false">
                <label
                  class="ui-checkbox"
                  :class="{ checked: cell.checked }"
                  @click="cell.checked = !cell.checked"
                  >{{ cell.subjectName }}</label
                >
                <input
                  v-if="cell.isNeedMark"
                  type="text"
                  :placeholder="
                    cell.markHoldPlace === 'optional'
                      ? $t('optional')
                      : $t('pleaseSpecify')
                  "
                  v-model="cell.mark"
                  class="subMore"
                />
              </td>
              <td v-if="cell.show">
                <label
                  class="ui-radio"
                  :class="{ checked: cell.subjectLevel === 2 }"
                  @click="cell.subjectLevel = 2"
                  >SL</label
                >
              </td>
              <td v-if="cell.show">
                <label
                  class="ui-radio"
                  :class="{ checked: cell.subjectLevel === 1 }"
                  @click="cell.subjectLevel = 1"
                  >HL</label
                >
              </td>
            </tr>
          </table>
          <!-- 学习课程不能为空 -->
          <p class="ui-error">{{ $t('formRule.course') }}</p>
        </div>
      </div>
      <div class="row-two row" v-for="n in 5" :key="n">
        <div class="half">
          <div class="lab" :class="{ require: n === 1 }">
            {{ $t('form.targetunivercity') }} {{ n }}:
          </div>
          <div class="content">
            <input
              type="text"
              @focus="empty.targetUniversitys = false"
              v-model="universityArr[n - 1]"
              class="fill-input"
            />
          </div>
        </div>
        <div class="half">
          <div class="lab" :class="{ require: n === 1 }">
            {{ $t('form.degreecourse') }}:
          </div>
          <div class="content">
            <input type="text" v-model="collegeArr[n - 1]" class="fill-input" />
          </div>
        </div>
      </div>
      <!--  目标大学不能为空 -->
      <p class="ui-error ui-error-university" v-show="empty.targetUniversitys">
        {{ $t('formRule.university') }}
      </p>
      <div class="row app-header" v-if="!!type">
        <!-- require -->
        <div class="lab">{{ $t('form.avatar') }}：</div>
        <!-- :class="{ isError: empty.userPhotoUrl }" -->
        <div class="content">
          <div class="img-list">
            <el-upload
              :headers="myHeaders"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="uploadAvatar"
              :data="uploadData"
              name="uploadFile"
              :with-credentials="true"
            >
              <img
                v-if="info.userPhotoUrl"
                :src="info.userPhotoUrl"
                style="object-fit: cover"
                class="avatar"
              />
              <i class="img-add" v-else></i>
            </el-upload>
          </div>
          <!-- 个人头像不能为空 -->
          <!-- <p class="ui-error">{{ $t('formRule.photo') }}</p> -->
        </div>
      </div>
      <div class="bottom">
        <a class="btn-submit" @click="submit">{{ $t('common.submit') }}</a>
      </div>
    </div>
    <div class="ui-pop" v-if="showTeacher">
      <div class="ui-mask"></div>
      <div class="teachlist">
        <router-link to="/home" class="btn-close"
          ><i class="el-icon-close"></i
        ></router-link>
        <router-link to="/home" class="btn-skip"
          >{{ $t('skip') }} >></router-link
        >
        <card :info="teacherList[current]" :showOrder="false"></card>
        <ul class="view-list">
          <li
            v-for="(item, index) in teacherList"
            :key="item.teacherId"
            @click="current = index"
          >
            <div class="avatar" :class="{ on: index === current }">
              <el-image class="img" :src="item.teacherPhotoUrl" fit="cover" />
              <p class="tip">{{ $t('details') }}</p>
            </div>
            <p class="name">{{ item.teacherName }}</p>
            <p class="course">IB {{ $t('common.course') }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Select from '@/components/Select.vue'
import card from '@/components/TeacherCard.vue'
import baseUrl from '@/service/env.js'
import { getTeacherList } from '@/service/teacherApi.js'
import { profectProfile, getMyProfile } from '@/service/studentApi.js'
import {
  getCourseList,
  getSubjectList,
  updateUserPhoto,
} from '@/service/api.js'
import { regStudentByEmail, regStudentByMobile } from '@/service/studentApi.js'
import VanDate from 'vant/lib/datetime-picker';
import moment from 'moment'
export default {
  components: { Select, card, VanDate },
  data() {
    return {
      momentInfo: '',
      info: {
        lastName: '',
        firstName: '',
        birthday: '',
        sex: 1,
        linkMobileNo: '',
        linkEmail: '',
        studentIdCard: '',
        school: '',
        schoolYear: 11,
        englishSpokenLevel: 1,
        course: 1,
        targetUniversitys: '',
        targetColleges: '',
        studiedSubjects: [],
        userPhotoUrl: '',
        wechat: '',
        skype: '',
        // studiedSubjectLevels: ''
      },
      currentSchoolYear: [
        { name: this.$t('year8'), value: 7 },
        { name: this.$t('year9'), value: 8 },
        { name: this.$t('year10'), value: 9 },
        { name: this.$t('year11'), value: 10 },
        { name: this.$t('year12'), value: 11 },
        { name: this.$t('year13'), value: 12 },
      ],
      levelArr: [
        { name: this.$t('enLevel1'), value: 1 },
        { name: this.$t('enLevel2'), value: 2 },
        { name: this.$t('enLevel3'), value: 3 },
      ],
      uploadUrl: baseUrl + '/upload/uploadPic',
      uploadData: { fn: 'edu', dw: 100, dh: 100 },
      collegeArr: ['', '', '', '', ''],
      universityArr: ['', '', '', '', ''],
      empty: {
        lastName: false,
        firstName: false,
        birthday: false,
        linkMobileNo: false,
        linkEmail: false,
        // school: false,
        schoolYear: false,
        // studentIdCard: false,
        studiedSubjects: false,
        targetUniversitys: false,
        // wechat: false,
      },
      subjectList: [], //科目列表
      courseList: [], //课程列表
      type: 0, // 首次进入为0，不展示头像上传
      teacherList: [],
      current: 0,
      showTeacher: false,
      minDate: new Date(1950, 0, 1),
    }
  },
  mounted() {
    this.initSubject()
  },
  methods: {
    changeBirth(birth) {
      if (!!this.info.birthday) {
        this.momentInfo = moment(this.info.birthday).format(
          'DD/MM/YYYY'
        )
      }
      // console.log(this.info.birthday);
    },
    async getInfo() {
      let res = await getMyProfile()
      if (res.data.status === 1) {
        for (let val in this.info) {
          // console.log(!!res.data.linkMobileNo);
          // console.log(val);
          if (val === 'birthday') {
            this.info[val] = moment(res.data[val], 'YYYYMMDD').format(
              'YYYY-MM-DD'
            )
          } else if (!!res.data.linkMobileNo && val === 'linkMobileNO') {
            // console.log(res.data.linkMobileNo);
            this.info.linkMobileNo = res.data.linkMobileNo
          } else if (val === 'userPhotoUrl' && !!res.data.userPhotoUrl) {
            // console.log(res.data.userPhotoUrl);
            this.info.userPhotoUrl = res.data.userPhotoUrl
          } else {
            this.info[val] = res.data[val]
          }
        }
        this.universityArr = !!res.data.targetUniversitys?res.data.targetUniversitys.split('$_$'):''
        this.collegeArr = !!res.data.targetColleges?res.data.targetColleges.split('$_$'):''
        let id = 0
        for (let j = 0; j < this.subjectList.length; j++) {
          if (this.subjectList[j].courseId == res.data.course) {
            id = j
          }
        }
        for (let i = 0; i < res.data.studiedSubjects.length; i++) {
          for (let n = 0; n < this.subjectList[id].arr.length; n++) {
            if (
              this.subjectList[id].arr[n].subjectId ===
              res.data.studiedSubjects[i].subjectId
            ) {
              this.subjectList[id].arr[n].checked = true
              this.subjectList[id].arr[n].mark =
                res.data.studiedSubjects[i].mark
              this.subjectList[id].arr[n].subjectLevel =
                res.data.studiedSubjects[i].subjectLevel
            }
          }
        }
        if(!!this.info.course===false){
          this.info.course=1;
        }
        this.$forceUpdate()
      }
    },
    async initSubject() {
      // 获取课程与科目列表
      let res = await getCourseList()
      if (res.data.status === 1) {
        let arr = []
        this.courseList = res.data.data
        for (let i = 0; i < this.courseList.length; i++) {
          let obj = { state: false }
          obj.courseId = this.courseList[i].courseId
          res = await getSubjectList({ courseId: obj.courseId })
          if (res.data.status === 1) {
            obj.arr = res.data.data
            for (let j = 0; j < obj.arr.length; j++) {
              // console.log(obj.arr[j]);
              obj.arr[j].subjectLevel = ''
              obj.arr[j].mark = ''
              obj.arr[j].checked = false
              if (obj.courseId === 2) {
                if (obj.arr[j].isNeedLevel === 1) {
                  obj.arr[j].show = true
                }
              }
            }
            obj.arr.sort((a1, b1) => {
              let a = a1.subjectName.toLowerCase()
              let b = b1.subjectName.toLowerCase()
              if (a < b) return -1
              if (a > b) return 1
              return 0
            })
            this.subjectList.push(obj)
            if (this.subjectList.length === this.courseList.length) {
              if (this.$route.query.type == 1) {
                this.type = 1
                this.getInfo()
                // this.getMyBankList()
              }
            }
            arr = arr.concat(obj.arr)
          }
        }
        const val = new Map()
        arr = arr.filter(
          (arr) => !val.has(arr.subjectName) && val.set(arr.subjectName, 1)
        )
        this.subjectList.push({ arr: arr })
      }
    },
    uploadSuccess(res, file, fileList) {
      // 学生证上传
      if (fileList.length === 2) {
        fileList.splice(0, 1)
      }

      this.info.studentIdCard = res.origUrl
      this.empty.studentIdCard = false
    },
    getStudentId() {
      if (!!this.info.studentIdCard) {
        let arr = this.info.studentIdCard.split('/')
        return arr[arr.length - 1]
      }
    },
    isEmpty(val) {
      // 值为空返回true，不为空返回false
      if (val === 'wechat') {
        // console.log(this.info)
        if (this.info.wechat === '' && this.info.skype === '') {
          this.empty[val] = true
          return true
        } else {
          return false
        }
      }
      if (this.info[val]) {
        return false
      } else {
        this.empty[val] = true
        return true
      }
    },
    resetErr(val) {
      this.empty[val] = false
    },
    submit() {
      let obj1 = !!this.$route.query.obj
        ? JSON.parse(this.$route.query.obj)
        : ''
      this.getCheckSubject()
      this.getTargetInfo()
      const info = JSON.parse(JSON.stringify(this.info))
      info.linkMobileNO = info.linkMobileNo
      delete info.linkMobileNo
      if (document.body.clientWidth >= 768) {
        info.birthday = moment(this.info.birthday).format('YYYYMMDD')
      } else {
        info.birthday = moment(this.info.birthday).format('YYYYMMDD')
      }
      let state = true
      for (let obj in this.empty) {
        if (this.isEmpty(obj)) {
          state = false
        }
      }

      if (state) {
        // this.info.userName = this.info.firstName + ' ' + this.info.lastName
        let submit1, submit2
        if (!!obj1) {
          if (!!obj1.mobileNO) {
            submit1 = new Promise((resolve, reject) => {
              regStudentByMobile(Object.assign(obj1, info))
                .then((res) => {
                  let user = {
                    loginState: true,
                    userType: 10,
                    uid: this.user.uid,
                    userName: this.info.firstName + this.info.lastName,
                    userPhoto: this.info.userPhotoUrl,
                  }
                  this.$store.dispatch('SETUSER', user)
                  resolve(res.data)
                })
                .catch((err) => {
                  reject(err)
                })
            })
          } else {
            submit1 = new Promise((resolve, reject) => {
              regStudentByEmail(Object.assign(obj1, info))
                .then((res) => {
                  let user = {
                    loginState: true,
                    userType: 10,
                    uid: this.user.uid,
                    userName: this.info.firstName + this.info.lastName,
                    userPhoto: this.info.userPhotoUrl,
                  }
                  this.$store.dispatch('SETUSER', user)
                  resolve(res.data)
                })
                .catch((err) => {
                  reject(err)
                })
            })
          }
        } else {
          info.email = info.linkEmail
          info.mobileNO = info.linkMobileNO
          delete info.linkMobileNO
          delete info.linkEmail
          submit1 = new Promise((resolve, reject) => {
            profectProfile(info)
              .then((res) => {
                let user = {
                  loginState: true,
                  userType: 10,
                  uid: this.user.uid,
                  userName: this.info.firstName + this.info.lastName,
                  userPhoto: this.info.userPhotoUrl,
                }
                this.$store.dispatch('SETUSER', user)
                resolve(res.data)
              })
              .catch((err) => {
                reject(err)
              })
          })
        }
        if (!!this.info.userPhotoUrl) {
          submit2 = new Promise((resolve, reject) => {
            updateUserPhoto({ userPhoto: this.info.userPhotoUrl })
              .then((res) => {
                resolve(res.data)
              })
              .catch((err) => {
                reject(err)
              })
          })
        }
        if (!!submit2) {
          Promise.all([submit1, submit2]).then((res) => {
            if (res[0].status === 1 && res[1].status === 1) {
              if (this.type === 1) {
                this.$message({
                  type: 'success',
                  message: this.$t('common.updateSuccess'),
                })
                this.$router.push({ path: '/user/info' })
                // this.$router.push({ path: '/user/info' })
              } else {
                // this.getTeacherList()
                // this.showTeacher = true
                if (document.body.clientWidth >= 768) {
                  this.$message({
                    type: 'success',
                    message: this.$t('common.regSuccess'),
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: this.$t('common.phoneUpdateSuccess'),
                    duration: 6000,
                  })
                }
                this.$router.push({ path: '/home' })
              }
            }
          })
        } else {
          submit1.then((res) => {
            if (res.status === 1) {
              if (this.type === 1) {
                let user = {
                  loginState: true,
                  userType: 10,
                  uid: this.user.uid,
                  userName: this.info.firstName + this.info.lastName,
                  userPhoto: this.info.userPhotoUrl,
                }
                this.$store.dispatch('SETUSER', user)
                this.$message({
                  type: 'success',
                  message: this.$t('common.updateSuccess'),
                })
                this.$router.push({ path: '/user/info' })
              } else {
                if (document.body.clientWidth >= 768) {
                  this.$message({
                    type: 'success',
                    message: this.$t('common.regSuccess'),
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: this.$t('common.phoneUpdateSuccess'),
                    duration: 6000,
                  })
                }
                this.$router.push({ path: '/home' })
              }
            }
          })
        }
      }
    },
    getCheckSubject() {
      // 整合选中的课程及科目
      let subject = [],
        level = [],
        id = 0
      for (let i = 0; i < this.subjectList.length; i++) {
        if (this.subjectList[i].courseId == this.info.course) {
          id = i
        }
      }
      let obj = this.subjectList[id].arr
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].checked) {
          subject.push(obj[i])
          // level.push(obj[i].level)
        }
      }
      this.info.studiedSubjects = JSON.stringify(subject)
    },
    getTargetInfo() {
      let arr1 = [],
        arr2 = []
      for (let i = 0; i < this.universityArr.length; i++) {
        if (this.universityArr[i]) {
          arr1.push(this.universityArr[i])
          arr2.push(this.collegeArr[i])
        }
      }
      this.info.targetUniversitys = arr1.join('$_$')
      this.info.targetColleges = arr2.join('$_$')
    },
    uploadAvatar(res, file) {
      this.$set(this.info, 'userPhotoUrl', res.origUrl)
    },
    async getTeacherList() {
      let res = await getTeacherList({
        courseId: 0,
        pageNO: 1,
        pageSize: 7,
        isRecommend: 0,
        totalCount: 0,
      })
      if (res.data.status === 1) {
        this.teacherList = res.data.data
      }
    },
  },
  computed: {
    myHeaders() {
      // 上传头部带token
      return { Authorization: 'TOKEN ' + sessionStorage.getItem('1to1token') }
    },
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
}
</script>
<style lang="scss" scoped>
.fill-box {
  padding: 60px 40px 42px;
}
.row {
  padding: 0 70px 0 360px;
  margin-bottom: 20px;
  position: relative;
}
.row-two {
  display: flex;
  padding: 0 150px;
  .half {
    flex: 1;
    position: relative;
    padding-left: 200px;
  }
  .lab {
    width: 180px;
  }
  & + .ui-error {
    display: block;
    padding-left: 360px;
  }
}
.lab {
  position: absolute;
  top: 0;
  left: 0;
  width: 340px;
  text-align: right;
  line-height: 42px;
}
.require:before {
  content: '*';
  color: #f00;
}
.fill-input {
  width: 100%;
  height: 42px;
  border-radius: 42px;
  padding: 10px 22px 10px 22px;
  line-height: 20px;
  border: 1px solid #ededed;
  background: #ededed;
  &:focus {
    border-color: #002147;
  }
}
.subList {
  margin: -20px -60px 0 0;
  overflow: hidden;
  li {
    float: left;
    margin-top: 20px;
    padding-right: 50px;
  }
  .fill-input {
    width: 274px;
  }
  .num {
    display: inline-block;
    width: 42px;
    text-align: right;
  }
}
.bottom {
  margin: 100px 0;
  text-align: center;
}
.btn-submit {
  display: inline-block;
  border-radius: 60px;
  height: 60px;
  min-width: 320px;
  background: #002147;
  color: #fff;
  line-height: 60px;
  font-size: 18px;
}
.englishLevel .ui-select {
  display: block;
}
.uploadStudentId {
  overflow: hidden;
  .fill-input {
    width: 375px;
    display: inline-block;
    text-align: left;
  }
  .btn-upload {
    display: inline-block;
    width: 80px;
    height: 42px;
    border-radius: 0 21px 21px 0;
    background: #169bd5;
    line-height: 42px;
    text-align: center;
    color: #fff;
    margin: 0 20px 0 -80px;
    vertical-align: top;
  }
  .el-upload-list {
    display: inline-block;
    height: 42px;
    line-height: 42px;
    vertical-align: top;
  }
}
.ui-error {
  display: none;
}
.isError {
  .ui-error {
    display: block;
  }
  .fill-input,
  .fill-area {
    border-color: red;
  }
}
.avatar {
  width: 100%;
  height: 100%;
  vertical-align: top;
}
.teachlist {
  background: #fff;
  position: relative;
  width: 1200px;
  padding: 40px 20px 80px 30px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.05);
  .btn-close {
    font-size: 20px;
    color: #8a8a8a;
    position: absolute;
    top: 24px;
    right: 24px;
  }
  .btn-skip {
    position: absolute;
    bottom: 30px;
    right: 50px;
    font-size: 16px;
    color: #666;
  }
}
.view-list {
  display: flex;
  justify-content: center;
  border-top: 1px solid #eee;
  margin: 25px 30px 0;
  padding-top: 50px;
  li {
    margin: 0 10px;
    width: 120px;
    text-align: center;
    cursor: pointer;
    &:hover .tip {
      opacity: 1;
    }
  }
  .avatar {
    width: 90px;
    height: 90px;
    margin: 0 auto;
    border-radius: 50%;
    overflow: hidden;
    font-size: 0;
    position: relative;
    .img {
      width: 100%;
      height: 100%;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
  .name {
    margin-top: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .course {
    color: #555;
    margin-top: 5px;
  }
  .on .tip {
    opacity: 1;
  }
  .tip {
    height: 35px;
    background: rgba(38, 128, 235, 0.55);
    color: #fff;
    text-align: center;
    line-height: 35px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 14px;
    opacity: 0;
    transition: opacity 0.3s;
  }
}
.subMore {
  border: 0;
  border-bottom: 1px solid #ddd;
  width: 200px;
  &:focus {
    border-color: #002147;
  }
}
.ui-error-university {
  margin: 10px 0;
}
.app-birthday {
  display: block;
}
.app-birthday1 {
  display: none;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  // .app-register{
  //   display: none;
  // }
  .bottom {
    margin: 20px 0;
  }
  .app-birthday {
    display: none;
  }
  .app-birthday1 {
    display: block;
  }
  .birthday,
  .app-header,
  .app-studentId {
    display: none;
  }
  .ui-wrap,
  .fill-box {
    padding: 0;
  }
  .ui-box {
    width: 100%;
    padding: 0 10px;
    // display: flex;
  }
  .lab {
    position: initial;
    text-align: initial;
  }
  .uploadStudentId >>> .el-upload {
    position: relative;
  }
  .uploadStudentId {
    .btn-upload {
      margin: 0;
      position: absolute;
      right: 0;
      border-radius: 0;
      // width: calc(100% - 80px);
    }
  }
  .row {
    padding: 0;
  }
  .row-two {
    display: block;
    .lab {
      width: 100%;
    }
  }
  .row-two .half {
    padding: 0;
  }
  .ui-error-university {
    padding: 0 !important;
  }
}
</style>
<i18n>
{
  "cn": {
    "optional":"选填",
    "pleaseSpecify":"请注明科目",
    "enLevel1":"基础",
    "enLevel2":"中级",
    "enLevel3":"流利",
    "wechart":"微信号",
    "year8":"初中一年級",
    "year9":"初中二年級",
    "year10":"初中三年級",
    "year11":"高中一年級",
    "year12":"高中二年級",
    "year13":"高中三年級",
    "skip":"跳过",
    "details":"详情",
    "formRule":{
      "surname":"姓氏不能为空",
      "name":"名字不能为空",
      "studentId":"学生证不能为空",
      "birthday":"生日不能为空",
      "email":"邮件不能为空",
      "phone":"手机号不能为空",
      "schoolYear":"当前年级不能为空",
      "course":"学习课程不能为空",
      "skypeWechat":"Skype 与 Wechat 不能同时为空",
      "school":"当前学校不能为空",
      "university":"目标大学不能为空",
      "photo":"个人头像不能为空"
    }
  },
  "TW": {
    "optional":"選填",
    "pleaseSpecify":"請註明科目",
    "enLevel1":"基礎",
    "enLevel2":"中級",
    "enLevel3":"流利",
    "wechart":"微信號",
    "year8":"國中一年級",
    "year9":"國中二年級",
    "year10":"國中三年級",
    "year11":"高中一年級",
    "year12":"高中二年級",
    "year13":"高中三年級",
    "skip":"跳過",
    "details":"詳情",
    "formRule":{
      "surname":"姓氏不能為空",
      "name":"名字不能為空",
      "studentId":"學生證不能為空",
      "birthday":"生日不能為空",
      "email":"郵件不能為空",
      "phone":"手機號不能為空",
      "schoolYear":"當前年級不能為空",
      "course":"學習課程不能為空",
      "skypeWechat":"Skype 與 Wechat 不能同時為空",
      "school":"當前學校不能為空",
      "university":"目標大學不能為空",
      "photo":"個人頭像不能為空"
    }
  },
  "en": {
    "optional":"optional",
    "pleaseSpecify":"please specify",
    "enLevel1":"Basic",
    "enLevel2":"Intermediate",
    "enLevel3":"Fluent",
    "wechart":"Wechat",
    "year8":"Year 8",
    "year9":"Year 9",
    "year10":"Year 10",
    "year11":"Year 11",
    "year12":"Year 12",
    "year13":"Year 13",
    "skip":"skip",
    "details":"details",
     "formRule":{
      "surname":"Last name cannot be empty",
      "name":"Name cannot be empty",
      "studentId":"Student ID cannot be empty",
      "birthday":"Birthday cannot be empty",
      "email":"Email cannot be empty",
      "phone":"Mobile phone number cannot be empty",
      "schoolYear":"Current grade cannot be empty",
      "course":"Learning course cannot be empty",
      "skypeWechat":"Skype and Wechat cannot be empty at the same time",
      "school":"The current school cannot be empty",
      "university":"Target university cannot be empty",
      "photo":"Personal portrait cannot be empty"
    }
  }
}
</i18n>